import jsonSKY from './wonderwall-project-SKY.json';
import jsonDGO from './wonderwall-project-DGO.json';
import { APP_THEME, isCustomSkinActive } from '../utils/env';

const root = document.documentElement;

// passing values from PX to REM
// context value replicates value from rem function of SCSS
function rem(px, context = 20) {
  const numericPx = typeof px === 'string' ? Number.parseFloat(px.replace('px', '')) : px;
  const numericContext = typeof context === 'string' ? Number.parseFloat(context.replace('px', '')) : context;

  const result = numericPx / numericContext;

  return `${result}rem`;
}

if (isCustomSkinActive) {
  const theme = APP_THEME;
  const json = theme === 'skymais' ? jsonSKY : jsonDGO; // DGO default
  const { typography } = json;

  for (const [index, key] of Object.keys(typography).entries()) {
    const font = typography[key];

    root.style.setProperty(`--font-family-${key}`, `"${font.fontFamily}"`);
    root.style.setProperty(`--font-weight-${key}`, font.fontWeight);
    root.style.setProperty(`--font-size-${key}`, rem(font.fontSize));
    root.style.setProperty(`--line-height-${key}`, rem(font.lineHeight));
    root.style.setProperty(`--letter-spacing-${key}`, `${font.spacing}%`);

    if (index === Object.keys(typography).length - 1) {
      document.body.classList.add('loaded');
    }
  }
}
